import React from 'react';
export const AuthenticationContextState = React.createContext({
    status: 'loading',
    user: undefined,
    workspace: undefined,
});
export const AuthenticationContextDispatch = React.createContext(() => { });
